export function getClaimStatusBadge(
  claimStatus: string
): { label: string; variant: 'destructive' | 'neutral' } | null {
  if (claimStatus === 'REJECTED') {
    return { label: 'Rejected', variant: 'destructive' };
  }
  if (claimStatus === 'CANCELLED') {
    return { label: 'Voided', variant: 'neutral' };
  }
  return null;
}
